<template>
	<div class="ReLeadStaffInfoMessage mt-3" v-if="objData">
		<div class="staffBlock pb-1" v-if="objData.staff_info_poz_name!=''">
			<h6>{{ objData.staff_info_poz_name }}</h6>	
			<p class="d-flex">{{ structure_name }}</p>
			<div class="d-flex justify-content-between">
				<div class="d-flex mr-3 align-items-center" v-if="objData.staff_info_mobile_phone && objData.staff_info_mobile_phone !=''">
					<p  class="mr-2"><b>Моб.: </b>{{ objData.staff_info_mobile_phone }}</p>
					<template v-if="this.lead_id && this.lead_id !=''">
						<RePhoneCallButton
							v-if="objData.staff_info_mobile_phone && objData.staff_info_mobile_phone !=''"
							:phone="objData.staff_info_mobile_phone"
							:lead_id="this.lead_id"
							borderStyle="noborder"
						/>
					</template>
				</div>

				<div class="d-flex align-items-center" v-if="objData.staff_info_internal_phone && objData.staff_info_internal_phone !=''">
					<p class="mr-2"><b>Доб.: </b>{{ objData.staff_info_internal_phone }}</p>
					<template v-if="this.lead_id && this.lead_id !=''">
						<RePhoneCallButton
							v-if="objData.staff_info_internal_phone && objData.staff_info_internal_phone !=''"
							:phone="objData.staff_info_internal_phone"
							:lead_id="this.lead_id"
							borderStyle="noborder"
						/>
					</template>
				</div>
			</div>
		</div>
		
		<div> 
			<ReLeadMessageButton 
				:staff_name="objData.staff_info_fio"
				:staff_code="objData.staff_info_code"
				:obj_type="'LEAD'" 
				:obj_id="this.lead_id"
				:obj_name="'callcenter'"
				:client_id="client_id"
				:messageSent="messageSent"
				/>
		</div>

		<div class="bossBlock pt-2 mt-2" v-if="objData.staff_info_boss_name && objData.staff_info_boss_name!=''">
			<p v-if="!showBoss" @click="showBoss=true"><b>Руководитель: </b> <span class="link">показать</span></p>
			<template v-else>

				<p class="" v-if="objData.staff_info_boss_name && objData.staff_info_boss_name !=''"><b>Руководитель: </b>{{ objData.staff_info_boss_name }}</p>
				
				<div class="d-flex justify-content-between">
					<div class="d-flex mr-3 align-items-center" v-if="objData.staff_info_boss_mobile_phone && objData.staff_info_boss_mobile_phone !=''">
						<p class="mr-2"><b>Моб.: </b>{{ objData.staff_info_boss_mobile_phone }}</p>
						<template v-if="this.lead_id && this.lead_id !=''">
							<RePhoneCallButton
								v-if="objData.staff_info_boss_mobile_phone && objData.staff_info_boss_mobile_phone !=''"
								:phone="objData.staff_info_boss_mobile_phone"
								:lead_id="this.lead_id"
								borderStyle="noborder"  
							/>
						</template>
					</div>
					<div class="d-flex align-items-center" v-if="objData.staff_info_boss_internal_phone && objData.staff_info_boss_internal_phone !=''">
						<p class="mr-2"><b>Доб.: </b>{{ objData.staff_info_boss_internal_phone }}</p>
						<template v-if="this.lead_id && this.lead_id !=''">
							<RePhoneCallButton
								v-if="objData.staff_info_boss_internal_phone && objData.staff_info_boss_internal_phone !=''"
								:phone="objData.staff_info_boss_internal_phone"
								:lead_id="this.lead_id"
								borderStyle="noborder"
							/>
						</template>
					</div>
				</div>
			</template>
		</div>

		<div v-if="showBoss"> 
			<ReLeadMessageButton 
				:staff_name="objData.staff_info_boss_name"
				:staff_code="objData.staff_info_boss_code"
				:obj_type="'LEAD'" 
				:obj_id="this.lead_id"
				:obj_name="'callcenter'"
				placeholder="Сообщение руководителю"
				:client_id="client_id"
				/>
			<!-- <div v-else class="d-flex w-100 text-warning">Телеграм руководителя не подключен!</div> -->
		</div>


	</div>

</template>



<script>
	import { /*Tooltip,*/ Button } from 'element-ui';
	import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
	// import ReBranchPrint from 'src/our_components/ReBranchPrint.vue';
	import ReLeadMessageButton from "src/our_components/ReLeadMessageButton.vue";

	export default {
		name: 'ReLeadStaffInfoMessage',
		components: {
			[Button.name]: Button,
			RePhoneCallButton,
			ReLeadMessageButton,
			// Tooltip,	
			// ReBranchPrint,
		},
		props: {
			value: [Object],
			lead_id: [Number, String],
			// objData: [Object, String],
			staffInfo: [String, Array],
			client_id: [Number, String],
			messageSent:{
				type: String,
				default:''
			},
		},
		data () {
			return {
				ver: 1,
				// objStaffExtra:{},
				// objBossExtra:{},
				objData:{},
				// bstaffExtraIsShown: false,
				// bbossExtraIsShown: false,
				showBoss:false,
			}
		},
		watch: {
			// staffInfo(val){
			// 	console.log('watch staffInfo ',val);
			// 	this.getAllStaffData();
			// },

			// staffInfo:{
			// 	handler: function(val){
			// 		console.log('watch staffInfo',val);
			// 		// this.getAllStaffData();
			// 	},
			// 	deep: true,
			// 	// immediate: true

			// },
			// objStaffExtra:{
			// 	handler: function(val){
			// 		console.log('watch objStaffExtra',val);
			// 		// this.getAllStaffData();
			// 	},
			// 	deep: true,
			// 	// immediate: true

			// },

		},
		computed: {
			structure_name(){
				if(this.objData && this.objData.staff_info_structure_name){
					const parts = String(this.objData.staff_info_structure_name).split('>');
					return parts.slice(-2).join('>');
				}return '';
			}
		},
		methods: {
			// getExtraDataForMessage(){
			// 	// console.log('beforeMount getExtraDataForMessage',this.objData.staff_info_code);
			// 	if(this.objData.staff_info_code!='' && this.objData.staff_info_code){
			// 	// for (let i = 0; i < this.masObjects.length; i++) {}
			// 		if(typeof this.objStaffExtra[this.objData.staff_info_code] == 'undefined'){
			// 			this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.objData.staff_info_code}})
			// 			.then((objApi) => {
			// 				if(objApi.success === true){
			// 					//  this.$set(this.objStaffExtra[this.objData.staff_info_code], 'this.objStaffExtra[this.objData.staff_info_code]', objApi.data[0]) 
			// 					this.objStaffExtra[this.objData.staff_info_code] = objApi.data[0];
			// 					this.bDataRecived = true;
			// 					// console.log('beforeMount this.objStaffExtra.telegram_id',this.objStaffExtra[this.objData.staff_info_code].telegram_id);
			// 				}
			// 			}).catch(errorObjApi => {console.log(errorObjApi);});
			// 		}
			// 	}	

			getAllStaffData(){
				
				if(this.staffInfo!='' && this.staffInfo!=undefined){
					this.objData = JSON.parse(this.staffInfo);

				// 	if(typeof this.objStaffExtra[this.objData.staff_info_code] == 'undefined'){
				// 		this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.objData.staff_info_code}},{useCache:true})
				// 		.then((objApi) => {
				// 			if(objApi.success === true){
				// 				this.objStaffExtra[this.objData.staff_info_code] = objApi.data[0];
				// 				this.bstaffExtraIsShown = true; // пока единственный найденный способ, чтобы данные по Апи успели получиться и только затем отрисовался компонент с инпутом
				// 				// console.log('this.bstaffExtraIsShown  ', this.bstaffExtraIsShown );
								
				// 			}
				// 		}).catch(errorObjApi => {console.log(errorObjApi);});
				// 	}

				// 	if(typeof this.objBossExtra[this.objData.staff_info_boss_code] == 'undefined'){
				// 		this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.objData.staff_info_boss_code}},{useCache:true})
				// 		.then((objApi) => {
				// 			if(objApi.success === true){
				// 				this.objBossExtra[this.objData.staff_info_boss_code] = objApi.data[0];
				// 				this.bbossExtraIsShown = true;
				// 				// console.log(this.objBossExtra);
				// 				// console.log('this.bbossExtraIsShown  ', this.bbossExtraIsShown );
				// 			}
				// 		}).catch(errorObjApi => {console.log(errorObjApi);});
				// 	}
					
					
					
				}

			},

		},
		beforeMount(){
			// console.log('beforeMount this.staffInfo ',this.staffInfo);
		},
		mounted(){
			// this.getExtraDataForMessage();

			if(this.staffInfo && this.staffInfo.length > 0){
				
				this.getAllStaffData();
				// console.log('this.objData ', this.objData);
				// console.log('beforeMount objStaffExtra ',this.objStaffExtra[this.objData.staff_info_code]);
			}
			// console.log('this.bstaffExtraIsShown  ', this.bstaffExtraIsShown );
			// console.log('this.bbossExtraIsShown  ', this.bbossExtraIsShown );
			
		},

		
	}
</script>
<style scoped lang="scss">

@import '../../src/assets/sass/dashboard/custom/_variables.scss';

.link{color:$primary-states; cursor:pointer}
.ReLeadStaffInfoMessage {display: flex; flex-direction: column;}
/* .ReLeadStaffInfo >>> .tree-list ul li, .ReLeadStaffInfo >>> .tree-list span, .ReLeadStaffInfo h6, .ReLeadStaffInfo p  {color: #303133;} */
/* .white-content .card:not(.card-white) >>> .ReLeadStaffInfo >>> .tree-list ul li, .white-content .card:not(.card-white) >>> .ReLeadStaffInfo >>> .tree-list span, .white-content .card:not(.card-white) >>> .ReLeadStaffInfo h6, .white-content .card:not(.card-white) >>> .ReLeadStaffInfo p  {color: #303133!important;} */
/* .ReLeadStaffInfoMessage >>> .tree-list ul li, .ReLeadStaffInfoMessage >>> .tree-list span, .ReLeadStaffInfoMessage h6, .ReLeadStaffInfoMessage p  {color: #000;} */
.bossBlock, .staffBlock {display: flex; flex-direction: column;  }
.bossBlock {border-top: 1px dashed #01B0E0;}
/* .ReLeadCallCat{
	padding: 10px;
	border: 1px dashed #01B0E0;
	border-radius: 6px;
	width: 960px;
}
.ReLeadCallCat >>> .ReInputSearchDrop {width: 100%;}
.ReLeadCallCat >>> .ReInputSearchDrop > .form-group {width: 100%;}
.ReLeadCallCat >>> .callSearchDrop {display: flex; flex-direction: row;}

@media (max-width: 1300px){
	.ReLeadCallCat{width: 100%;}
} */

</style>
